import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import TorontoApply from '../TorontoApply';
import NycApply from '../NycApply';
import { Helmet } from 'react-helmet';
import './apply.css';

class Apply extends Component {
  componentDidMount() {}

  render() {
    return (
      <Query
        query={gql`
          {
            currentUser {
              id
              firstName
              lastName
              email
              mobile
              existingUberPartner
              uberProfileImage
              driversLicenseImage
              driversLicenseNumber
              tlcNumber
              employmentEligibilityImage
              ssnImage
              ssn
              uberxStatus
              status
              transitNumber
              institutionNumber
              accountNumber
              accountName
              operatingCity
              viaStatus
            }
          }
        `}>
        {({ loading, error, data, refetch }) => {
          if (loading) return null;
          if (error) {
            console.log('ERROR', error);
            return <Redirect to="/404" />;
          }
          if (data && data.currentUser) {
            if (
              ![
                'subscribed',
                'lead',
                'signed_up',
                'fleet_pending',
                'tlc_pending',
                'account_pending'
              ].includes(data.currentUser.status)
            ) {
              return <Redirect to="/dashboard" />;
            }
            return (
              <div className="apply">
                <Helmet>
                  <title>Sign Up | Autzu</title>
                  <meta
                    name="description"
                    content="Sign up to drive with Autzu."
                  />
                </Helmet>
                {data.currentUser.operatingCity === 'toronto' ? (
                  <TorontoApply
                    location={this.props.location}
                    loadUser={this.props.tryUpdateInfo}
                    refetch={refetch}
                    currentUser={data.currentUser}
                    history={this.props.history}
                  />
                ) : (
                  <NycApply
                    location={this.props.location}
                    loadUser={this.props.tryUpdateInfo}
                    refetch={refetch}
                    currentUser={data.currentUser}
                    history={this.props.history}
                  />
                )}
              </div>
            );
          }
          return null;
        }}
      </Query>
    );
  }
}
export default Apply;



// WEBPACK FOOTER //
// ./src/components/NewApply/index.js